<template>
  <b-card no-body :header="header" tag="article" class="mb-2">
    <b-card-text class="p-3 m-0">
      <b-form-file drop-placeholder="將檔案拖曳至此" browse-text="瀏覽" placeholder="尚未選擇檔案"
        accept="image/jpeg, image/png, image/gif" :file-name-formatter="formatFilename" @input="loadImage" />
    </b-card-text>

    <div v-if="!file">
      <b-card-img
        :src="waitingImage"
        alt="Image"
        class="rounded-0"
      />
    </div>
    <div v-else>
      <b-card-img
        :src="imageUrl"
        alt="Image"
        bottom
      />
    </div>
  </b-card>
</template>

<script>
import mixin from '../lib/mixin.js';
import waitingImage from '../assets/waiting-image.png';

export default {
  name: 'BaseImageInput',
  mixins: [mixin],
  props: {
    header: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      waitingImage,
      file: null,
      imageUrl: null,
    };
  },
  methods: {
    async loadImage(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageUrl = reader.result;
      };

      this.file = file;
      this.$emit('loaded', file);
    },
    formatFilename(files) {
      return files[0].name;
    },
  },
};
</script>
